var map = {
	"./netskope.png": 5177,
	"./partner-1.webp": 2882,
	"./partner-10.webp": 4766,
	"./partner-11.webp": 9273,
	"./partner-12.webp": 8764,
	"./partner-13.webp": 6703,
	"./partner-14.webp": 802,
	"./partner-15.webp": 5741,
	"./partner-16.webp": 7424,
	"./partner-17.webp": 1123,
	"./partner-18.webp": 2166,
	"./partner-19.webp": 7489,
	"./partner-2.webp": 6851,
	"./partner-20.webp": 9653,
	"./partner-21.webp": 6298,
	"./partner-22.webp": 2587,
	"./partner-23.webp": 4696,
	"./partner-24.webp": 9969,
	"./partner-25.webp": 214,
	"./partner-26.webp": 9479,
	"./partner-27.webp": 5444,
	"./partner-28.webp": 7613,
	"./partner-3.webp": 3152,
	"./partner-4.webp": 1353,
	"./partner-5.webp": 494,
	"./partner-6.webp": 2431,
	"./partner-7.webp": 4492,
	"./partner-8.webp": 7413,
	"./partner-9.webp": 6794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2228;